<template>
  <select v-model="model" class="is-show-param">
    <option :value="true">{{ $t('show') }}</option>
    <option :value="false">{{ $t('hide') }}</option>
  </select>
</template>

<script>
export default {
  name: 'IsShowParam',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: Boolean,
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
      },
    },
  },
}
</script>

<style lang="scss">
.is-show-param {
  position: relative !important;
  padding: 10px 24px 10px 10px !important;
  background-position: 90% center !important;
}
</style>
